import { Component } from '@angular/core';
import {NgForOf} from '@angular/common';
import {items} from '../../../../../model/menu';
import {Services} from '../../../../../model/services';

@Component({
  selector: 'app-services-section',
  imports: [
    NgForOf
  ],
  templateUrl: './services-section.component.html',
  styleUrl: './services-section.component.scss'
})
export class ServicesSectionComponent {
  q: number = 200;

  getActive(id: string) {
    let isVisible = false;
    const el = document.getElementById(id);
    const scheduleDistance = el?.getBoundingClientRect();
    if (scheduleDistance) {
      isVisible = -scheduleDistance.top + this.q >= 0 &&
        -scheduleDistance.top + this.q - 60 <= scheduleDistance.height;
      return isVisible;
    }
    return undefined;

  }

  protected readonly items = items;
  protected readonly Services = Services;
}
